<div class="space-y-6">
  @for (problem of problems(); track problem.title) {
    <div class="space-y-4 border border-border-secondary rounded-[20px] p-6">
      <div class="space-y-2">
        <h4>{{ problem.title }}</h4>
        @if (problem.description) {
          <p class="text-text-secondary">{{ problem.description }}</p>
        }
      </div>

      @if (problem.images && problem.images.length > 0) {
        <div class="grid grid-cols-2 gap-4 sm:grid-cols-3">
          @for (image of problem.images; track image.image_url) {
            <div class="flex flex-col gap-3">
              @if (image.image_url) {
                <img
                  [src]="image.image_url"
                  [alt]="problem.title"
                  class="h-32 w-32 rounded-lg object-cover border-solid border-2 border-border-secondary" />
              }

              @if (image.video_thumbnail) {
                <img
                  [src]="image.video_thumbnail"
                  [alt]="problem.title"
                  class="h-32 w-32 rounded-lg object-cover border-solid border-2 border-border-secondary" />
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
